// extracted by mini-css-extract-plugin
module.exports = {"heading":"_3P0zM","hidden":"_1uQN1"};